import types from './actionTypes';

export const createFilesPool = (poolName, initialState) => ({
    type: types.CREATE_FILES_POOL,
    payload: {
        poolName,
        initialState,
    },
});

export const removeFilesPool = poolName => ({
    type: types.REMOVE_FILES_POOL,
    payload: {
        poolName,
    },
});

export const addFile = (filesPool, payload) => ({
    type: types.ADD_FILE,
    meta: { filesPool },
    payload,
});

export const setFile = (filesPool, payload) => ({
    type: types.SET_FILE,
    meta: { filesPool },
    payload,
});

export const removeFile = (filesPool, id) => ({
    type: types.REMOVE_FILE,
    meta: { filesPool },
    payload: {
        id,
    },
});

export const uploadRequest = (filesPool, file) => ({
    type: types.UPLOAD_REQUEST,
    meta: { filesPool },
    payload: {
        file,
    },
});
